export default __webpack_public_path__ + "static/G6_ND_25_2021RGB2Spiral-01 - Copy-fr-2df47f0d180167faed1fc13868180b30.svg";